import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import SearchIcon from '../../assets/img/icon-search.svg';
import GoBackButton from './GoBackButton';
import GoBackProfileButton from './GoBackProfileButton';
import MoreButton from './MoreButton';
// home
export function HomeNav({ title, to }) {
  return (
    <TopNavWrap>
      <h1>만들만들 {title}</h1>
      <Link to={to}>
        <img className='search' src={SearchIcon} alt='검색하기 아이콘' />
      </Link>
    </TopNavWrap>
  );
}

// 검색, input있는 버전
export function SearchNav({ onChange, value }) {
  return (
    <TopNavWrap>
      <GoBackButton />
      <input
        id='search-input'
        type='text'
        onChange={onChange}
        value={value}
        placeholder='계정 검색'
      />
    </TopNavWrap>
  );
}

// 뒤로가기 + 더보기
export function MoreNav({ onClick }) {
  return (
    <TopNavWrap>
      <GoBackButton />
      <MoreButton onClick={onClick} />
    </TopNavWrap>
  );
}

// 뒤로가기만 있는 버전
export function GoBackNav({ children }) {
  return (
    <TopNavWrap>
      <div>
        <GoBackButton />
        <h1>{children}</h1>
      </div>
    </TopNavWrap>
  );
}

// 마이 프로필로 이동하는 버전
export function GoBackProfileNav() {
  return (
    <TopNavWrap>
      <GoBackProfileButton />
    </TopNavWrap>
  );
}

export const TopNavWrap = styled.header`
  display: flex;
  gap: 20px;
  width: 100%;
  height: 48px;
  background-color: #ffffff;
  border-bottom: 1px solid #dbdbdb;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;

  & > div {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  div + div {
    display: flex;
  }

  input {
    width: 316px;
    height: 32px;
    border-radius: 32px;
    border: none;
    background-color: #f2f2f2;
    padding-left: 16px;
    font-size: 14px;
  }

  button,
  a {
  }
`;
